import React, { memo, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  formatterPercentBarChartTwoDataSet,
  getTranslationAnswerByQuantity,
} from '../../../../shared/utils/smartutils';
import ChartHorizontalBars from '../../../../shared/components/ChartHorizontalBars';
import colors from '../../../../shared/utils/colors';
import ChartLabels from '../../../../shared/components/ChartLabels';

const SummaryBooleanAnswer = ({ t, answer }) => {
  const htmlRef = useRef(null);
  const { question, chartData } = answer;

  const getColorByHasData = (data) => {
    return data.dataset.data[0] ? 'white' : 'black';
  };

  const options = {
    animation: {
      duration: 0,
    },
    scales: {
      xAxes: [
        {
          tooltip: false,
          stacked: false,
          ticks: {
            min: 0,
            stepSize: 1,
          },
        },
      ],
      yAxes: [
        {
          tooltip: false,
          stacked: false,
        },
      ],
    },

    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      enabled: false,
    },
    plugins: {
      datalabels: {
        formatter: formatterPercentBarChartTwoDataSet,
        color: getColorByHasData,
        anchor: 'center',
        align: 'right',
        offset: 1,
      },
    },
  };

  const buildData = (data) => {
    return {
      labels: '',
      datasets: [
        {
          label: t('answers.true'),
          data: [data.trueQuantity],
          backgroundColor: colors[0],
        },
        {
          label: t('answers.false'),
          data: [data.falseQuantity],
          backgroundColor: colors[1],
        },
      ],
    };
  };

  const hasData = () => {
    return !!chartData && chartData.length;
  };

  useEffect(() => {
    if (question && htmlRef) {
      htmlRef.current.innerHTML = question.description;
    }
  }, [question]);

  return (
    <div className="mb-3 bg-light p-3">
      <div ref={htmlRef} className="mb-3" />
      <div className="mb-3">
        {`${question.numberOfAnswer} ${getTranslationAnswerByQuantity(
          question.numberOfAnswer
        )}`}
      </div>
      <div className="w-100 d-flex justify-content-center mb-3">
        <ChartLabels
          direction="horizontal"
          labels={[t('answers.true'), t('answers.false')]}
        />
      </div>
      <div className="d-flex align-items-center flex-column">
        <div className="w-100 mb-3">
          {hasData() &&
            chartData.map((data) => (
              <>
                <div key={data.label}>{data.label}</div>
                <div className="flex-2 mb-3">
                  <ChartHorizontalBars
                    data={buildData(data)}
                    options={options}
                    height={100}
                    legend={{
                      display: false,
                    }}
                  />
                </div>
              </>
            ))}
        </div>
      </div>
    </div>
  );
};

SummaryBooleanAnswer.propTypes = {
  t: PropTypes.func.isRequired,
  answer: PropTypes.shape({
    question: PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.number,
      type: PropTypes.string,
      numberOfAnswer: PropTypes.number,
    }),
    chartData: PropTypes.arrayOf(
      PropTypes.shape({
        descritiveAnswer: PropTypes.string,
        falseQuantity: PropTypes.number,
        label: PropTypes.string,
        responsible: PropTypes.string,
        trueQuantity: PropTypes.number,
        value: PropTypes.number,
      })
    ),
  }).isRequired,
};

export default withTranslation('common')(memo(SummaryBooleanAnswer));
